import React from 'react';
import { BaasicInput, BaasicSelect, BaasicCheckbox, BaasicDropdown } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';
import _ from 'lodash';

const UserCreateTemplate = ({
	t,
	userCreateViewStore: {
		loadingRoles,
		userRoles,
		selectedRoles,
		onRoleChange,
		form,
		loading,
		selectedLabelPrinter,
		onChangeLabelPrinter,
		selectedPackingSlipPrinter,
		onChangePackingSlipPrinter,
		getPrinters,
		printerOptions,
		notification,
		showNotification,
		hasPiiAccess,
		canSetPii,
		isHavingAPISecret,
		generateApiSecret,
		onCheckPiiAccess,
		onCheckEnableEmailNotification,
		canSetEnableEmailNotification,
		enableEmailNotification,
		isCountryLoading,
		countryOptions,
		onSelectChange,
		onMenuClose,
		onUserPhoneChange,
		isSuperAdmin,
		organizationDropdownStore,
	},
}) => {
	return (
		<form className="ReactModal__form" onSubmit={form.onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{translate('CREATEUSER')}</h3>
			</div>
			<div className="ReactModal__body">
				{isSuperAdmin && (
					<BaasicDropdown
						dropdownStore={organizationDropdownStore}
						placeholder={t('PLACEHOLDER.ORGANIZATION')}
						className="w--200--px spc--right--sml"
					/>
				)}
				<BaasicInput autoFocus field={form.$('userName')} />
				<BaasicInput field={form.$('email')} />
				<BaasicSelect
					field={form.$('countryCode')}
					value={form.$('countryCode').value}
					onChange={value => onSelectChange(value, form.$('countryCode'))}
					options={countryOptions.slice()}
					onMenuClose={() => onMenuClose()}
					isLoading={isCountryLoading}
					clearable={false}
				/>
				<BaasicInput
					field={form.$('userPhone')}
					onKeyUp={onUserPhoneChange(form.$('userPhone').value)}
					disabled={form.$('countryCode').isEmpty}
				/>
				<BaasicInput field={form.$('password')} className="fs-mask" />
				<BaasicInput field={form.$('confirmPassword')} className="fs-mask" />
				<BaasicSelect
					field={form.$('roles')}
					isMulti={true}
					loading={loadingRoles}
					options={userRoles}
					value={selectedRoles.slice()}
					defaultValue={selectedRoles.slice()}
					onChange={onRoleChange}
					className="spc--bottom--sml flex--grow--1"
				/>
				<div className="inputgroup">
					<div className="inputgroup--main">
						<BaasicInput field={form.$('apiKey')} className="fs-mask" />
					</div>
					<div className="inputgroup--aside align--v--bottom">
						<button
							className="btn btn--med btn--secondary spc--left--sml spc--bottom--sml"
							type="button"
							disabled={loading}
							onClick={getPrinters}
						>
							{translate('LOGINFORM.PRINTNODE.GETPRINTERS')}
						</button>
					</div>
					{showNotification && <p className="type--color--warning spc--bottom--sml">{translate(notification)}</p>}
				</div>
				<BaasicSelect
					field={form.$('labelPrinterId')}
					value={selectedLabelPrinter}
					onChange={onChangeLabelPrinter}
					validation={false}
					options={printerOptions}
					isClearable={true}
					className="spc--bottom--sml flex--grow--1"
				/>
				<BaasicSelect
					field={form.$('packingSlipPrinterId')}
					value={selectedPackingSlipPrinter}
					onChange={onChangePackingSlipPrinter}
					validation={false}
					options={printerOptions}
					isClearable={true}
					className="spc--bottom--sml flex--grow--1"
				/>
				<div className="inputgroup">
					<div className="inputgroup--main">
						<BaasicInput field={form.$('apiSecret')} className="fs-mask" disabled />
					</div>
					<div className="inputgroup--aside align--v--bottom">
						{!isHavingAPISecret ? (
							<button
								className="btn btn--med btn--secondary spc--bottom--sml spc--left--sml"
								type="button"
								onClick={generateApiSecret}
							>
								{translate('LOGINFORM.GENERATEAPISECRET')}
							</button>
						) : null}
					</div>
					{showNotification && <p className="type--color--warning spc--bottom--sml">{translate(notification)}</p>}
				</div>
				<div className="spc--bottom--sml">
					<BaasicCheckbox
						className="input--check"
						id="pii-access"
						onChange={onCheckPiiAccess}
						label={'LOGINFORM.PIIACCESS'}
						checked={hasPiiAccess}
						disabled={!canSetPii}
					/>
				</div>
				{canSetEnableEmailNotification &&
					_.find(selectedRoles.slice(), role => {
						return role.label == 'Warehouse Administrator' || role.label == 'Warehouse Account Owner';
					}) && (
						<div className="spc--bottom--sml">
							<BaasicCheckbox
								id="enable-email-notification"
								onChange={onCheckEnableEmailNotification}
								label={'USEREDIT.EMAILNOTIFICATION'}
								checked={enableEmailNotification}
							/>
						</div>
					)}
				{form.error && (
					<div>
						<p className="type--color--warning">{translate(form.error)}</p>
					</div>
				)}
			</div>
			<div className="ReactModal__footer">
				<button className="btn btn--med btn--primary spc--bottom--sml" type="submit" disabled={loading}>
					{loading ? (
						<div className="spinnercont spc--right--sml">
							<div className="spinner"></div>
						</div>
					) : null}
					{translate('SAVE')}
				</button>
			</div>
		</form>
	);
};

export default defaultTemplate(UserCreateTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/user/pages/UserCreateTemplate.jsx